import * as React from 'react'

interface IconProps {
  width?: number
  height?: number
}

const DisclaimerIcon = ({ width = 28, height = 28, ...props }: IconProps) => {
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 28 28"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <g clipPath="url(#clip0_380_524)">
        <path
          d="M23.9143 27.9947H4.08554C1.05235 27.9947 -0.920449 24.8026 0.43602 22.0897L10.3504 2.26084C11.8541 -0.746539 16.1457 -0.746539 17.6494 2.26084L27.5638 22.0896C28.9203 24.8026 26.9475 27.9947 23.9143 27.9947Z"
          fill="url(#paint0_linear_380_524)"
        />
        <path
          d="M23.9143 27.9947H4.08554C1.05235 27.9947 -0.920449 24.8026 0.43602 22.0897L10.3504 2.26084C11.8541 -0.746539 16.1457 -0.746539 17.6494 2.26084L27.5638 22.0896C28.9203 24.8026 26.9475 27.9947 23.9143 27.9947Z"
          fill="url(#paint1_linear_380_524)"
        />
        <path
          d="M26.5817 22.5807L16.6673 2.75188C16.1512 1.71959 15.154 1.10332 13.9999 1.10332C12.8459 1.10332 11.8487 1.71959 11.3326 2.75188L1.41816 22.5807C0.952548 23.5119 1.00133 24.5966 1.5487 25.4822C2.09606 26.3679 3.04445 26.8967 4.08554 26.8967H23.9144C24.9554 26.8967 25.9038 26.3679 26.4512 25.4822C26.9985 24.5966 27.0473 23.512 26.5817 22.5807ZM25.5172 24.905C25.1713 25.4645 24.5722 25.7986 23.9144 25.7986H4.08554C3.42776 25.7986 2.82855 25.4645 2.48276 24.905C2.13691 24.3455 2.10607 23.6601 2.40029 23.0717L12.3146 3.24297C12.6456 2.58103 13.2598 2.20139 13.9999 2.20139C14.74 2.20139 15.3542 2.58103 15.6851 3.24297L25.5995 23.0718C25.8938 23.6601 25.863 24.3455 25.5172 24.905Z"
          fill="url(#paint2_linear_380_524)"
        />
        <path
          d="M23.9142 27.9945H22.3529L13.3276 18.9692C13.0607 18.8386 12.9267 18.6129 12.9267 18.2906C12.9267 17.0729 12.8768 16.2044 12.7769 13.4483C12.6769 10.6927 12.627 10.1267 12.627 8.909C12.627 8.52028 12.7592 8.22054 13.0239 8.00917C13.288 7.79726 13.6305 7.69182 14.0511 7.69182C14.4716 7.69182 14.7807 7.80163 14.9773 8.0218C15.0152 8.06353 23.2427 16.2884 26.0828 19.1273L27.564 22.0898C28.9207 24.8025 26.9476 27.9945 23.9142 27.9945Z"
          fill="url(#paint3_linear_380_524)"
        />
        <path
          d="M21.7093 27.9945H17.6257L12.9442 23.313C12.633 23.0385 12.4771 22.7184 12.4771 22.3522C12.4771 21.9706 12.633 21.6462 12.9442 21.3794C13.2555 21.1125 13.6338 20.9791 14.0785 20.9791C14.47 20.9791 14.8087 21.1125 15.0942 21.3794L21.7093 27.9945Z"
          fill="url(#paint4_linear_380_524)"
        />
        <path
          d="M12.4771 22.352C12.4771 21.9705 12.6327 21.6464 12.9439 21.3796C13.2552 21.1127 13.6335 20.979 14.0782 20.979C14.4698 20.979 14.8083 21.1127 15.0938 21.3796C15.3793 21.6464 15.5225 21.9705 15.5225 22.352C15.5225 22.7182 15.3794 23.0385 15.0938 23.313C14.8083 23.5877 14.4698 23.7249 14.0782 23.7249C13.6335 23.7249 13.2552 23.5876 12.9439 23.313C12.6327 23.0385 12.4771 22.7182 12.4771 22.352ZM12.6268 8.90906C12.6268 8.5205 12.759 8.22038 13.0235 8.00895C13.288 7.79753 13.6304 7.69171 14.0509 7.69171C14.4714 7.69171 14.7803 7.8018 14.9773 8.02175C15.1742 8.2417 15.2729 8.5374 15.2729 8.90906C15.2729 10.1269 15.2518 10.6926 15.2106 13.4486C15.1688 16.2046 15.1482 17.0731 15.1482 18.2904C15.1482 18.5444 15.0293 18.7433 14.7917 18.8868C14.5538 19.0303 14.3068 19.1022 14.051 19.1022C13.3014 19.1022 12.9265 18.8318 12.9265 18.2904C12.9265 17.0731 12.8765 16.2046 12.7767 13.4486C12.6767 10.6925 12.6268 10.1268 12.6268 8.90906Z"
          fill="white"
        />
      </g>
      <defs>
        <linearGradient
          id="paint0_linear_380_524"
          x1={7.02246}
          y1={11.9764}
          x2={38.9626}
          y2={43.9166}
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#FFB92D" />
          <stop offset={1} stopColor="#F59500" />
        </linearGradient>
        <linearGradient
          id="paint1_linear_380_524"
          x1={11.2625}
          y1={16.2164}
          x2={20.8905}
          y2={25.8438}
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#FFB92D" />
          <stop offset={1} stopColor="#F59500" />
        </linearGradient>
        <linearGradient
          id="paint2_linear_380_524"
          x1={1.10057}
          y1={14.0003}
          x2={26.8988}
          y2={14.0003}
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#FFF465" />
          <stop offset={1} stopColor="#FFE600" />
        </linearGradient>
        <linearGradient
          id="paint3_linear_380_524"
          x1={23.1418}
          y1={22.5149}
          x2={7.54505}
          y2={6.91813}
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#BE3F45" stopOpacity={0} />
          <stop offset={1} stopColor="#BE3F45" />
        </linearGradient>
        <linearGradient
          id="paint4_linear_380_524"
          x1={18.0915}
          y1={26.4215}
          x2={13.0039}
          y2={21.3333}
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#BE3F45" stopOpacity={0} />
          <stop offset={1} stopColor="#BE3F45" />
        </linearGradient>
        <clipPath id="clip0_380_524">
          <rect width={28} height={28} fill="white" />
        </clipPath>
      </defs>
    </svg>
  )
}
export { DisclaimerIcon }
